import React, { PureComponent } from 'react';
import { object, string } from 'prop-types';
import styled from 'styled-components';
import Collapse from '@material-ui/core/Collapse';
import ClinicPhoto from '../../HeaderCard/components/ClinicPhoto';
import StarRating from '../../../SolvPatternLibrary/StarRating';
import Button from '../../../SolvPatternLibrary/Button';
import history from '../../../../core/history';
import { isEmptyObject } from '../../../../core/util/object';
import { colors } from '../../../../constants/colors';
import { fontSize, fontFamily } from '../../../../constants/text';
import { pluralize } from '../../../../core/util/string';
import { getLocationRatingAndRatingCount } from '../../../../core/util/location';
import { CDP_TELEMED_MODULE_CLICK } from '../../../../core/analytics/events';
import { analyticsTrackEvent } from '../../../../core/analytics';
import { buildBookingWidgetUrl } from '../../../../core/url/location';

const Root = styled.div`
  border-radius: 4px;
  border: 1px solid ${colors.borderLine};
  box-sizing: border-box;
  text-align: center;
  width: 100%;
  margin: 24px auto;
`;

const Banner = styled.div`
  font-family: ${fontFamily.medium};
  font-size: ${fontSize.medium};
  padding: 20px 10px;
  background-color: ${colors.whiteGrey};
  color: ${colors.squid};
  text-align: center;
  border-bottom: 1px solid ${colors.borderLine};
  letter-spacing: -0.23px;
`;

const SubInfo = styled.div`
  font-family: ${fontFamily.book};
  font-size: ${fontSize.mediumSmall};
  color: ${colors.blueLoadingScreen};
  margin: 20px auto 6px;
`;

const TelemedPhoto = styled(ClinicPhoto)`
  margin: 6px auto;
  width: 80px;
  height: 80px;
`;

const ClinicName = styled.div`
  margin: 6px auto;
  color: ${colors.link};
  font-family: ${fontFamily.bold};
  font-size: ${fontSize.medium};
  text-decoration: none;
`;

const ClinicRating = styled.div`
  margin: 6px auto;
`;

const ClinicStars = styled(StarRating)`
  display: inline-block;
`;

const RatingCount = styled.span`
  color: ${colors.lanaDelGrey};
  font-family: ${fontFamily.book};
  font-size: ${fontSize.small};
  line-height: 24px;
  vertical-align: top;
  padding: 0 0 0 5px;
`;

const TelemedBookButton = styled.a`
  display: inline-block;
  color: ${colors.white} !important;
  background-color: ${colors.crunchBerry};
  border-radius: 4px;
  font-family: ${fontFamily.book};
  font-size: ${fontSize.small};
  letter-spacing: -0.12px;
  padding: 8px 16px;
  text-align: center;
`;

const TelemedText = styled.div`
  margin: 6px auto 24px;
  font-family: ${fontFamily.book};
  font-size: ${fontSize.small};
  color: ${colors.lightText};
`;

export default class NearbyTelemed extends PureComponent {
  static propTypes = {
    location: object,
    className: string,
    referrerId: string,
  };

  handleClickBook = () => {
    const { location, referrerId } = this.props;
    analyticsTrackEvent(CDP_TELEMED_MODULE_CLICK, {
      locationId: location.id,
      referringLocationId: referrerId,
    });
  };

  render() {
    const { location, referrerId } = this.props;
    const { rating, ratingCount } = getLocationRatingAndRatingCount(location);

    return (
      <Collapse in={!isEmptyObject(location)} timeout="auto" mountOnEnter>
        <Root>
          <Banner>VIDEO VISIT</Banner>
          <SubInfo>
            Instantly video conference with a top-rated
            <br />
            healthcare provider. No downloads required.
          </SubInfo>
          <TelemedPhoto location={location} />
          <ClinicName>{location.displayNamePrimary}</ClinicName>
          <ClinicRating>
            <ClinicStars
              size={fontSize.mediumSmall}
              rating={rating || 0}
              identifier={`${location.id}-telemed-module`}
            />
            <RatingCount>
              {ratingCount || 'No'} {pluralize(ratingCount, 'rating')}
            </RatingCount>
          </ClinicRating>
          <TelemedBookButton
            onClick={this.handleClickBook}
            href={buildBookingWidgetUrl(location, 'CDP', referrerId)}
          >
            Book Now
          </TelemedBookButton>
          <TelemedText>See a doctor ASAP or on your schedule</TelemedText>
        </Root>
      </Collapse>
    );
  }
}
